import { defineMessages } from '@approvalmax/utils';

export const messages = defineMessages('app.wallets.KycDetails.DetailsStep', {
    pleaseProvideInfo: 'Please provide information required for completing {companyName} onboarding process',
});
